import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from 'smartsuite-ui';
import {
    getIndicatorStatus,
    getIndicatorColorFromStatus,
    valueWithSign,
} from '../../valueDisplay/numberWithIndicator/numberWithIndicatorUtils';
import { noDataIdentifier } from '../../../../shared/constants/constants';

// eslint-disable-next-line complexity
export default function ThresholdCompare({
    colorWhenBad,
    colorWhenGood,
    expectValueOverThreshold,
    formatValue,
    isLeftAligned,
    suffix,
    threshold,
    value,
}) {
    if (!threshold || threshold.value === undefined) {
        return (
            <TableCell cssClassModifiers={[isLeftAligned ? 'left-align' : '']}>
                {noDataIdentifier}
            </TableCell>
        );
    }

    const indicatorStatus = getIndicatorStatus(
        value,
        threshold.value,
        expectValueOverThreshold
    );

    const indicatorColor = getIndicatorColorFromStatus(
        indicatorStatus,
        colorWhenBad,
        colorWhenGood
    );

    const differenceToThreshold = parseFloat(value) - threshold.value;
    const displayValue = valueWithSign(
        differenceToThreshold,
        suffix,
        formatValue
    );

    return (
        <TableCell
            title={`Threshold Value: ${threshold.value}`}
            cssClassModifiers={[isLeftAligned ? 'left-align' : '']}
        >
            <span style={{ color: indicatorColor }}>
                {`${displayValue}${suffix}`}
            </span>
        </TableCell>
    );
}

ThresholdCompare.propTypes = {
    colorWhenBad: PropTypes.bool,
    colorWhenGood: PropTypes.bool,
    expectValueOverThreshold: PropTypes.bool,
    formatValue: PropTypes.func.isRequired,
    isLeftAligned: PropTypes.bool,
    suffix: PropTypes.string,
    threshold: PropTypes.instanceOf(Object),
    value: PropTypes.number,
};

ThresholdCompare.defaultProps = {
    colorWhenBad: true,
    colorWhenGood: false,
    expectValueOverThreshold: true,
    isLeftAligned: false,
    suffix: '',
    threshold: undefined,
};
